import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import {
  getSlideGenerator,
  useCreateSlideOutlineGenerator,
  useGetSlideGenerator,
} from "@packages/api/madlenAPI";
import {
  CreateSlideGeneratorOutlineRequestDtoCourseType,
  SlideGeneratorResponseDto,
} from "@packages/api/madlenAPI.schemas";
import GenericToolCreationPage from "../../../tools/components/tool_components/GenericToolCreationPage";
import CreateModal, {
  CreateModalProps,
} from "../../../tools/components/create-modal";

const CreateSlideView = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const CreateModalWrapper = ({
    initialInput,
    onSubmit,
    isLoading,
    error,
  }: Partial<CreateModalProps>) => (
    <CreateModal
      title={t("slides.create.title")}
      backPath="/slides"
      themeColor="rose"
      loadingTitle={t("slides.create.loading.title")}
      loadingDescription={t("slides.create.loading.description")}
      errorTitle={t("slides.create.error.title")}
      errorDescription={t("slides.create.error.description")}
      submitButtonText={t("common.create")}
      initialInput={initialInput!}
      onSubmit={async (input) => {
        await onSubmit!({
          courseType:
            input.courseName as CreateSlideGeneratorOutlineRequestDtoCourseType,
          grade: Number(input.gradeLevel),
          topic: input.lessonTopic,
          environment: input.environment,
          includeImages: true,
          name: input.lessonTopic,
          description: input.lessonTopic,
          style: "CLASSROOM",
          learningOutcomeIds: input.learningOutcomeIds,
        });
      }}
      isLoading={isLoading!}
      error={error!}
    />
  );

  const ToolCardWrapper = ({
    toolData,
  }: {
    toolData: SlideGeneratorResponseDto;
  }) => {
    if (toolData?.presentation) {
      navigate(`/slides/${toolData.id}`);
    }
    return null;
  };

  return (
    <GenericToolCreationPage
      toolType="slides"
      useCreateTool={useCreateSlideOutlineGenerator}
      useGetTool={useGetSlideGenerator}
      getTool={getSlideGenerator}
      ToolCard={ToolCardWrapper}
      CreateModalWrapper={CreateModalWrapper}
      toolDataExtractor={(data: SlideGeneratorResponseDto) =>
        data?.presentation
      }
    />
  );
};

export default CreateSlideView;
